import React, { ClipboardEvent, CSSProperties, useContext } from "react";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import { StyledTableCell } from "../../../../components/ShipmentSummary/components/SummaryGrid/SummaryGrid";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import ClickableCell from "../../../../components/ClickableCell/ClickableCell";
import { TABLE_BORDER_GRAY } from "../../../../constants/css.constants";
import Typography from "@mui/material/Typography";
import { SeasonToMonthContext } from "../../../../contexts/SeasonToMonthContext";
import Table from '@mui/material/Table';

type SeasonToMonthShipmentTableProps = {
  additionalHeaders: Array<string>;
  data: Array<Array<any>>;
  disabled?: boolean;
  horizontalHeaders: Array<string>;
  optionalStyles?: (value: number, column: number) => CSSProperties;
  updateData: (row: number, column: number) => (value: string) => void;
  verticalHeaders: Array<string>;
  transform: (value: number) => string;
  onPaste?: (
    row: number,
    column: number,
  ) => (e: ClipboardEvent<HTMLTableCellElement>) => void;
  tab: string;
};

const SeasonToMonthShipmentTable = ({
  data,
  disabled = false,
  additionalHeaders,
  horizontalHeaders,
  transform,
  updateData,
  verticalHeaders,
  optionalStyles,
  onPaste,
  tab,
}: SeasonToMonthShipmentTableProps) => {
  const { selectedCell, setNextCell } = useContext(SeasonToMonthContext);
  return (
    <TableContainer>
      <Table size="small">
      <TableHead>
        <TableRow>
          <StyledTableCell
            style={{
              borderTop: TABLE_BORDER_GRAY,
              minWidth: "100px",
            }}
            padding='none'
            size='small'
          >
            <Typography variant="h6">{tab}</Typography>
          </StyledTableCell>
          {horizontalHeaders.map((header) => (
            <StyledTableCell
              style={{ borderTop: TABLE_BORDER_GRAY }}
              key={header}
              padding='none'
              size='small'
            >
              {header}
            </StyledTableCell>
          ))}
          {additionalHeaders.map((header) => (
            <StyledTableCell
              style={{ borderTop: TABLE_BORDER_GRAY }}
              key={header}
              padding='none'
              size='small'
            >
              {header}
            </StyledTableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {verticalHeaders.map((verticalHeader, i) => (
          <TableRow key={verticalHeader}>
            <StyledTableCell style={{ minWidth: "100px" }}
                             padding='none'
                             size='small'
            >
              {verticalHeader}
            </StyledTableCell>
            {data[i].map((datum: number, j) => (
              <ClickableCell
                key={`${i}${j}`}
                transform={transform}
                disabled={j > 11 || disabled}
                type="number"
                styles={
                  optionalStyles
                    ? optionalStyles(datum, j)
                    : { minWidth: "110px" }
                }
                onPaste={onPaste && onPaste(i, j)}
                updateData={updateData(i, j)}
                value={datum}
                setNextCell={!disabled ? setNextCell(i, j) : () => () => {}}
                isSelected={
                  !disabled &&
                  selectedCell.row === i &&
                  selectedCell.column === j
                }
              />
            ))}
          </TableRow>
        ))}
      </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SeasonToMonthShipmentTable;
